import React, { useMemo } from 'react';
import { makeStyles, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import isEmpty from '../../../../../utils/isEmpty';
import Body2 from '../../../../common/typographys/Body2';
import Body1 from '../../../../common/typographys/Body1';
import CardBlock from '../../../../common/forms/CardBlock';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  nameType: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  type: {
    marginLeft: '5px',
  },
  groupName: {
    marginBottom: '10px',
  },
  reason: {
    marginTop: '5px',
    color: 'rgba(0,0,0,0.7)',
  },
  margin: {
    marginTop: '2px',
  },
}));

const UsersReasons = ({ users, reasons, isGroup }) => {
  const classes = useStyles();

  const reasonItems = useMemo(() => {
    if (!reasons || !Array.isArray(reasons)) {
      return [];
    }

    return reasons
      .filter(entry => entry && entry.vote === 'novote' && !isEmpty(entry.reason))
      .map(entry => {
        const reasonText = entry.reason && entry.reason.trim();
        if (isEmpty(reasonText)) return null;

        let userObj = null;
        let groupName = null;

        if (isGroup) {
          if (entry.group_id) {
            const foundGroup = users.find(
              g => g && g.id && g.id.toString() === entry.group_id.toString()
            );
            if (foundGroup && Array.isArray(foundGroup.users)) {
              userObj = foundGroup.users.find(
                u => u && u.id && u.id.toString() === entry.id.toString()
              );
            }
            if (foundGroup) {
              groupName = foundGroup.name;
            }
          }

          if (!userObj) {
            const group = users.find(
              grp =>
                grp &&
                Array.isArray(grp.users) &&
                grp.users.some(u => u && u.id && u.id.toString() === entry.id.toString())
            );
            if (group) {
              groupName = group.name;
              userObj = group.users.find(
                u => u && u.id && u.id.toString() === entry.id.toString()
              );
            }
          }

          if (!userObj) {
            userObj = { name: entry.name || '' };
          }
        } else {
          userObj = users.find(
            u => u && u.id && u.id.toString() === entry.id.toString()
          ) || { name: entry.name || '' };
        }

        return {
          id: entry.id,
          groupId: entry.group_id,
          name: (userObj && userObj.name) || '---',
          groupName: groupName || '',
          reason: reasonText,
        };
      })
      .filter(Boolean);
  }, [reasons, users, isGroup]);

  if (!reasonItems.length) {
    return null;
  }

  return (
    <>
      <Box height="18px" />
      <CardBlock label="Escusas de voto">
        {reasonItems.map(entry => (
          <Box key={`${entry.id}-${entry.groupId || 'nogroup'}`} mb={1}>
            <Box className={classes.nameType}>
              <Body1 oneLine>{entry.name}</Body1>
            </Box>
            {entry.groupName && (
              <Body2 className={clsx(classes.groupName, classes.margin)}>{entry.groupName}</Body2>
            )}
            <Body2 className={classes.reason}>{entry.reason}</Body2>
          </Box>
        ))}
      </CardBlock>
    </>
  );
};

UsersReasons.propTypes = {
  users: PropTypes.array.isRequired,
  reasons: PropTypes.array.isRequired,
  isGroup: PropTypes.bool.isRequired,
};

export default React.memo(UsersReasons);
